<template>
  <div class="sm:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
    <div v-for="f in fields" :key="f.key" :class="f.type === 'textarea' ? 'sm:col-span-2' : ''">
      <label class="text-xs font-medium text-gray-600 mb-1.5 block text-left">{{ f.label }}</label>

      <select
        v-if="f.type === 'select'"
        :value="value(f)"
        @change="set(f, $event.target.value)"
        :class="inputClass"
        class="w-full text-sm rounded-lg px-3 h-10 outline-none"
      >
        <option value="">-- Select --</option>
        <option v-for="opt in f.options || []" :key="opt" :value="opt">{{ opt }}</option>
      </select>

      <div v-else-if="f.type === 'checkbox'" class="flex items-center h-10">
        <div
          @click="set(f, !value(f))"
          :class="value(f) ? 'bg-green-500' : 'bg-gray-300'"
          class="relative w-10 h-5 rounded-full cursor-pointer transition-colors"
        >
          <div
            :class="value(f) ? 'translate-x-5' : 'translate-x-0'"
            class="absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform"
          ></div>
        </div>
      </div>

      <textarea
        v-else-if="f.type === 'textarea'"
        :value="value(f)"
        @input="set(f, $event.target.value)"
        rows="2"
        :class="inputClass"
        class="w-full text-sm rounded-lg px-3 py-2 outline-none"
      ></textarea>

      <input
        v-else
        :type="f.type === 'number' ? 'number' : 'text'"
        :value="value(f)"
        @input="set(f, $event.target.value)"
        :class="inputClass"
        class="w-full text-sm rounded-lg px-3 h-10 outline-none"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomFieldsInput",
  props: {
    // Mutated directly — matches how the job card handles every other field.
    job: { type: Object, required: true },
    fields: { type: Array, default: () => [] },
    inputClass: { type: String, default: "bg-gray-50 border border-gray-200" },
  },
  methods: {
    value(f) {
      const v = this.job[f.key];
      if (v === undefined || v === null) return f.type === "checkbox" ? false : "";
      return v;
    },
    set(f, v) {
      // $set, not plain assignment — the key may not exist on the job yet.
      this.$set(this.job, f.key, v);
    },
  },
};
</script>
